import React, { useState } from 'react';
import styles from './styles/SiteFeedbackModal.module.css';
import * as SiteFeedbackAPI from '../../services/SiteFeedbackServices';
import * as NotificationAPI from '../../services/NotificationServices';
import profileIcon from "../../images/profileicon.png";
import { FaCopy, FaUserSlash, FaUserPlus, FaMinus, FaTimes} from 'react-icons/fa'; 
import socket from '../../socket';

const ScenarioInviteModal = ({ isOpen, onClose, feedbackItem, userId, setAllFeedback, isAdmin, setSelectedFeedback }) => {
    const [closing, setClosing] = useState(false); 
    const [text, setText] = useState('');
    const triggerClose = () => {
        setClosing(true);
        setTimeout(() => {
            handleClose();
            setClosing(false);
        }, 300); 
    };

    const handleClose = () => {
        onClose();
    };

    if (!isOpen && !closing) return null;

    const addMessage = async () => {
        try {
            const feedbacks = await SiteFeedbackAPI.addMessage(feedbackItem._id, { sender: userId, text });
            
            socket.emit('addedMessage', { sender: userId, feedbackUser: feedbacks.sender._id, isAdmin, feedbackId: feedbackItem._id, feedback: feedbacks });
            
            setAllFeedback(prev => (
                    prev.map(obj =>
                        obj._id === feedbackItem._id
                        ? { ...obj, messages: feedbacks.messages, updatedAt: feedbacks.updatedAt }
                        : obj
                    )
                )
            );

            setSelectedFeedback(prev => ({ ...prev, messages: feedbacks.messages, updatedAt: feedbacks.updatedAt}));

            setText('');

            if(isAdmin){
                await NotificationAPI.sendSiteFeedback(feedbackItem.sender);
            }
        } catch (error) {
            console.error("Error fetching site feedback:", error);
        }
    }

    const handleOverlayClick = (e) => {
  if (e.target === e.currentTarget) {
    triggerClose();
  }
};

    return (
        <div className={`${styles.modalOverlay} ${closing ? styles.fadeOut : styles.fadeIn}`} onClick={handleOverlayClick}>
            <div className={styles.modalContent}>
                {/* Modal Header */}
                <div className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>Feedback Messages</h2>
                    <button className={styles.closeButton} onClick={triggerClose}><FaTimes/></button>
                </div>

                {/* Modal Body */}
                <div className={styles.modalBody}>
                    {feedbackItem?.messages.map((message, index) => (
                        <div
                            key={index}
                            className={`${styles.messageRow} ${
                                message.sender._id === userId ? styles.ownMessage : styles.otherMessage
                            }`}
                        >
                            {message.sender._id !== userId && (
                                <img
                                    src={message.sender.profilePicture || profileIcon}
                                    alt="User Icon"
                                    className={styles.profileIcon}
                                />
                            )}
                            <div className={styles.messageBubble}>
                                <span className={styles.senderName}>
                                    {message.sender._id === userId ? "You" : message.sender.username}
                                </span>
                                <div className={styles.messageText}>{message.text}</div>
                            </div>
                        </div>
                    ))}

                    {!feedbackItem.isClosed && <div className={styles.messageInputContainer}>
                        <textarea
                            className={styles.messageInput}
                            value={text}
                            placeholder="Type your message..."
                            onChange={(e) => setText(e.target.value)}
                            rows={1}
                            onInput={(e) => {
                                e.target.style.height = 'auto'; 
                                e.target.style.height = e.target.scrollHeight + 'px'; 
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    if (text.trim()) addMessage();
                                }
                            }}
                        />
                        <button
                            className={styles.sendButton}
                            onClick={() => text.trim() && addMessage()}
                        >
                            Send
                        </button>
                    </div>
            }
                </div>
            </div>
        </div>
    );
};

export default ScenarioInviteModal;
